<template>
  <div id="ClaimsReturnsMenu" class="container">
    <h1>Claims &amp; Returns</h1>
    <b-row class="returns">
      <b-col v-if="IsClaimsSectionEnabled" id="claimsComponent" class="row-eq-height" cols="12" lg="4">
        <div class="feature">
          <h2>Claims</h2>
          <div class="feature-content">
            <div class="row feature-content__header-row__div">
            <p class="large md-col-6 xs-col-12 sm-col-12">
              <strong>Was an error made by DealerNet on an order shipment?</strong>
            </p>
            <p class="md-col-6 xs-col-12 sm-col-12">
              A parts shipment claim allows you to notify DealerNet that an error was made in picking, packaging,
              shipping or invoicing a Sales Order.
            </p>
          </div>

            <div class="row">
            <div class="btn-group md-col-6 xs-col-12 sm-col-12">
              <div v-if="hasPermission('CanSubmitDiscrepancyClaims')">
                <router-link :to="{ name: 'CreateClaim' }" class="btn btn-large dn-btn-large">
                  START A CLAIM
                </router-link>
              </div>
            </div>

            <div v-if="IsClaimsSectionEnabled" id="claimsLinks" class="md-col-6 xs-col-12 sm-col-12">
              <div>
              <h5 v-if="hasPermission('CanViewReturns')" title="View Claims">
                View
              </h5>
              <ul v-if="hasPermission('CanViewReturns')">
                <li>
                  <router-link to="/claimsAndReturns/claims">
                    View Claims
                  </router-link>
                </li>
                <li v-if="ClaimsFilingInstructions != ''">
                  <a :href="ClaimsFilingInstructions" target="_blank">Claims Filing Instructions</a>
                </li>
                <li v-if="ClaimsPolicyLink != ''">
                  <a :href="ClaimsPolicyLink" target="_blank">Claims and Returns Policy</a>
                </li>
              </ul>
              </div>
            </div>
          </div>
          </div>
        </div>
      </b-col>
      <b-col v-if="IsReturnsSectionEnabled" id="returnsComponent" class="row-eq-height" cols="12" lg="4">
        <div class="feature">
          <h2>Returns</h2>
          <div class="feature-content">
            <div class="row feature-content__header-row__div">
            <p class="large md-col-6 xs-col-12 sm-col-12">
              <strong>Did you order a part in surplus?</strong>
            </p>
            <p class="md-col-6 xs-col-12 sm-col-12">
              A parts return allows you to notify DealerNet that a part was ordered in surplus, as a result of some
              action by you (the dealer), not DealerNet.
            </p>
          </div>

            <div class="row">
            <div id="divCreateReturnsSap" class="btn-group md-col-6 xs-col-12 sm-col-12">
              <div v-if="(hasPermission('CanSubmitExpressReturns') || hasPermission('CanSubmitAnnualReturns')) && !IsMcfs">
                <router-link :to="{ name: 'CreateReturn' }" class="btn btn-large dn-btn-large">
                  START A RETURN
                </router-link>
              </div>
            </div>

            <div v-if="IsReturnsSectionEnabled" id="returnsLinks" class="md-col-6 xs-col-12 sm-col-12">
              <div v-if="hasPermission('CanViewReturns')">
                <h5 title="View Returns">
                  View
                </h5>
                <ul>
                  <li>
                    <router-link to="/claimsAndReturns/returns">
                      View Returns
                    </router-link>
                  </li>
                  <li v-if="ClaimsPolicyLink != ''">
                    <a :href="ClaimsPolicyLink" target="_blank">Claims and Returns Policy</a>
                  </li>
                  <li v-if="ClaimsFilingInstructions != ''">
                    <a :href="ClaimsFilingInstructions" target="_blank">Claims Filing Instructions</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          </div>
        </div>
      </b-col>
      <b-col v-if="IsEntitlementsSectionEnabled" id="entitlementsComponent" class="row-eq-height" cols="12" lg="4">
        <div class="feature">
          <h2>Entitlements</h2>
          <div class="feature-content">
            <div class="row feature-content__header-row__div">
            <p class="large md-col-6 xs-col-12 sm-col-12">
              <strong><strong>Do you need to return a core</strong>?</strong>
            </p>
            <p class="md-col-6 xs-col-12 sm-col-12">Core Credit Requests allow you to submit Open Entitlements to our core processing center.</p>
          </div>

            <div class="row">
            <div class="btn-group md-col-6 xs-col-12 sm-col-12">
              <div>
                <router-link :to="{ name: 'Entitlements' }" class="btn btn-large dn-btn-large"
                  v-if="hasPermission('CanSubmitCCR')">
                  START CORE CREDIT REQUEST
                </router-link>
              </div>
            </div>

            <div v-if="IsEntitlementsSectionEnabled" id="entitlementsLinks" class="md-col-6 xs-col-12 sm-col-12">
              <div>
              <h5 title="View Entitlements">
                View
              </h5>
              <ul>
                <li v-if="hasPermission('CanViewCCR')">
                  <router-link :to="{ name: 'OpenCoreCreditRequests' }">
                    View Open CCRs
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'Entitlements', query: { showExpiredOnly: true } }">
                    Expired Entitlements
                  </router-link>
                </li>
                <li v-if="RemanPolicyLink != ''">
                  <a :href="RemanPolicyLink" target="_blank">Reman Policy Document</a>
                </li>
                <li v-if="CoreAcceptanceGroupsLink != ''">
                  <a :href="CoreAcceptanceGroupsLink" target="_blank">Core Acceptance Groups (CAG)</a>
                </li>
              </ul>
              </div>
            </div>
          </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <div class="row no-gutters">




    </div>
  </div>
</template>

<script>
import { siteSectionsHelper } from "@/components/mixins/siteSectionsHelper"
import { ReturnsService, ClaimsService, EntitlementsService } from "@/services"
import { sizeHelper } from "@/components/mixins/sizeHelper"
import { mapGetters } from "vuex"

export default {
  mixins: [siteSectionsHelper, sizeHelper],
  data: function () {
    return {
      ClaimsPolicyLink: "",
      ClaimsFilingInstructions: "",
      RemanPolicyLink: "",
      CoreAcceptanceGroupsLink: "",
    }
  },
  computed: {
    ...mapGetters(["hasPermission", "IsMcfs"])
  },
  mounted: function () {
    ReturnsService.GetReturnsPolicyTitle().then(title => {
      this.ClaimsPolicyLink = ReturnsService.GetReturnsPolicyUrl(title.data)
    })

    ClaimsService.GetClaimsFilingInstructionsTitle().then(title => {
      this.ClaimsFilingInstructions = ClaimsService.GetClaimsFilingInstructionsUrl(title.data);
    })

    this.RemanPolicyLink = EntitlementsService.GetFileUrlByTitle("Reman Policy Manual");
    this.CoreAcceptanceGroupsLink = EntitlementsService.GetFileUrlByTitle("Core Acceptance Groups (CAG)")
  }
}
</script>
